import React from "react";
import PropTypes from "prop-types";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

export default function AchievementsSection({ data }) {
  return (
    <MKBox display="flex" justifyContent="space-around" flexWrap="wrap" mb={6}>
      {data.map((item, index) => (
        <MKBox key={index} textAlign="center" p={2}>
          <MKTypography variant="h4" fontWeight="bold">
            <CountUp end={item.value} duration={2} redraw={true}>
              {({ countUpRef, start }) => (
                <VisibilitySensor onChange={start} delayedCall>
                  <span ref={countUpRef} />
                </VisibilitySensor>
              )}
            </CountUp>
            {item.suffix || ""}
          </MKTypography>
          <MKTypography variant="body2">{item.label}</MKTypography>
        </MKBox>
      ))}
    </MKBox>
  );
}

AchievementsSection.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      suffix: PropTypes.string,
    })
  ).isRequired,
};
